import * as Scrivito from "scrivito";
import defaultFormInputAttributes from "../../_defaultFormAttributes";

const CheckboxWidget = Scrivito.provideWidgetClass("CheckboxWidget", {
  attributes: {
    label: "string",
    ...defaultFormInputAttributes,
    checkboxOptions: ["widgetlist", { only: "CheckboxOptionWidget" }],
  },
  onlyInside: "FormPageWidget",
});

export default CheckboxWidget;
